import { useEffect, useState } from 'react';
import { HosApiDashboardLateCheckout } from '../../types/apiTypes';
import {
  DashboardCardTimespan,
  DashboardDataLateCheckout,
} from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useLateCheckoutAnalytics = () => {
  const [lateCheckoutAnalytics, setLateCheckoutAnalytics] = useState<
    DashboardDataLateCheckout[]
  >([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response && !loading)
      setLateCheckoutAnalytics(mapLateCheckoutAnalytics(response));
  }, [response, loading]);

  const getLateCheckoutAnalytics = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/LateCheckouts`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };

  return { lateCheckoutAnalytics, getLateCheckoutAnalytics, loading };
};

const mapLateCheckoutAnalytics = (
  lateCheckouts: HosApiDashboardLateCheckout[]
): DashboardDataLateCheckout[] => {
  return lateCheckouts.map((lco: HosApiDashboardLateCheckout) => {
    return {
      id: lco.Time,
      value: lco.Count,
      revenue: lco.Revenue,
    };
  });
};
